enum LineItemSeverity {
    SAFETY_CONCERN,
    WARNING,
    OK,
    ADDITIONAL,
    INITIAL_WORK
}

export default LineItemSeverity